import clsx from 'clsx'
import React from 'react'
import styled from 'styled-components'

import { FooterElement } from '@Components/Footer/styled'
import { TrustPilotWidget } from '@Components/TrustPilotWidget'
import { down, up } from '@Globals/Style/breakpoints'
import { useMediaQuery } from '@Globals/useMediaQuery'

interface StyledTrustPilotProps {
  borderBottomColor?: string
  borderTopColor?: string
}

const StyledTrustPilot = styled(FooterElement)<StyledTrustPilotProps>`
  order: 6;
  padding-top: 15px;
  padding-bottom: 15px;
  border-top: 1px solid ${({ borderTopColor, theme }) => borderTopColor
    ?? theme.colors.greyLighter};
  border-bottom: 1px solid ${({ borderBottomColor, theme }) => borderBottomColor
    ?? theme.colors.greyLighter};
  
  ${up('tablet')} {
    order: 2;
  }

  ${up('desktop')} {
    order: 3;
  }

  ${down('phablet')} {
    display: flex;
    width: 100%;
    justify-content: center;
  }
`

export const TrustPilot = () => {
  const isDesktop = useMediaQuery('(min-width:1024px)')

  return (
    <StyledTrustPilot
      className={clsx({
        top: isDesktop,
      })}
    >
      <TrustPilotWidget />
    </StyledTrustPilot>
  )
}
